const imp = () => import(/* webpackChunkName: "loadSprite_controls"*/  "../sprite/loadSprite_controls");
const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-Creator": imp,
  "Icon-Segmentselection": imp,
  "Icon-Taskdetails": imp,
  "Icon-Taskname": imp,
  "Icon-Taskprogress": imp,
  "Icon-personincharge": imp,
  "Icon-Tasktype": imp,
  "Icon-Creator03": imp,
  "Icon-Degreeofurgency": imp,
  "Icon-Sharer02": imp,
  "Icon-duedate": imp,
  "Icon-Startdate02": imp,
  "Icon-Creationtime": imp,
}
export default loadMap;
